var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { resolveChoice } from "utility/choice-columns";
export var cupChoiceKeys = [
    "size",
    "material",
    "hardness",
    "bellows",
];
export var getCupChoice = function (cup) {
    var _a, _b, _c, _d;
    return ({
        size: (_a = cup.size) !== null && _a !== void 0 ? _a : "",
        material: (_b = cup.material) !== null && _b !== void 0 ? _b : "",
        hardness: (_c = cup.hardness) !== null && _c !== void 0 ? _c : "",
        bellows: (_d = cup.bellows) !== null && _d !== void 0 ? _d : "",
    });
};
/** Whether the cups can be picked column by column: Tacton sends their sizes. */
export var hasCupChoices = function (cups) {
    return cups.length > 0 && cups.every(function (cup) { return !!cup.size; });
};
/* "8" before "10-2", "30" before "30/60", "B3" before "B6". */
var compareNumeric = new Intl.Collator("en", { numeric: true }).compare;
/**
 * The cups in the order the picker lists their options: by size, then
 * material (in Tacton's order, which lists the family's usual material
 * first), hardness and bellows. The top option of each column is so the
 * first cup that offers it.
 */
export var sortCupsByChoice = function (cups) {
    var materials = cups.map(function (cup) { var _a; return (_a = cup.material) !== null && _a !== void 0 ? _a : ""; });
    return __spreadArray([], __read(cups), false).sort(function (c1, c2) {
        var a = getCupChoice(c1);
        var b = getCupChoice(c2);
        return (compareNumeric(a.size, b.size) ||
            materials.indexOf(a.material) - materials.indexOf(b.material) ||
            compareNumeric(a.hardness, b.hardness) ||
            compareNumeric(a.bellows, b.bellows));
    });
};
/**
 * The cup of `familyCups` that best fits `wanted` (`resolveChoice`): picking
 * another size keeps the material, hardness and bellows where that size comes
 * with them, and with nothing wanted it is the top option of each column.
 */
export var resolveCupChoice = function (familyCups, wanted) {
    return resolveChoice(sortCupsByChoice(familyCups), getCupChoice, cupChoiceKeys, wanted);
};
/**
 * The picker's columns for the cups of one family, with `selectedCup` (when it
 * is one of them) picked in each: every size of the family, then the
 * materials that size comes in, the hardnesses of that size and material, and
 * so on. A column is left out when no cup of the family has a value for it,
 * e.g. the bellows, which only piGRIP and MX cups have.
 */
export var getCupChoiceColumns = function (familyCups, selectedCup) {
    var e_1, _a;
    var sorted = sortCupsByChoice(familyCups);
    var selected = selectedCup && sorted.some(function (cup) { return cup.value === selectedCup.value; })
        ? getCupChoice(selectedCup)
        : undefined;
    var columns = [];
    var offered = sorted;
    var _loop_1 = function (key) {
        if (!sorted.some(function (cup) { return getCupChoice(cup)[key]; }))
            return "continue";
        columns.push({
            key: key,
            values: Array.from(new Set(offered.map(function (cup) { return getCupChoice(cup)[key]; }))),
        });
        offered = offered.filter(function (cup) { return getCupChoice(cup)[key] === (selected === null || selected === void 0 ? void 0 : selected[key]); });
    };
    try {
        for (var cupChoiceKeys_1 = __values(cupChoiceKeys), cupChoiceKeys_1_1 = cupChoiceKeys_1.next(); !cupChoiceKeys_1_1.done; cupChoiceKeys_1_1 = cupChoiceKeys_1.next()) {
            var key = cupChoiceKeys_1_1.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (cupChoiceKeys_1_1 && !cupChoiceKeys_1_1.done && (_a = cupChoiceKeys_1.return)) _a.call(cupChoiceKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { columns: columns, selected: selected };
};
